import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import { InitialState } from './types'
import useDebounce from '../../hooks/useDebounce'

// Styles
import './styles.scss'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'
import ContestsDatabaseBlock from '../../components/ContestsDatabaseBlock'

// Icons
import IconSearch from './images/iconSearch'
import ImageGreenLeaf from '../ProfileContestsPage/images/imageGreenLeaf'

export default () => {
  const sizeButtons: [10, 20, 50] = [10, 20, 50]

  const [search, setSearch] = useState<string>('')
  const [limit, setLimit] = useState<10 | 20 | 50>(10)
  const [page, setPage] = useState<number>(1)

  const dispatch = useDispatch()
  const history = useHistory()

  const isMounted = useRef<boolean>(false)
  const hasLoaded = useRef<boolean>(false)

  const debouncedSearchTerm = useDebounce(search, 500)

  const { contest, works, metaWorks, isFetchingContests, isFetchingWorks } =
    useSelector(
      (state: { profileContestWorksList: InitialState }) =>
        state.profileContestWorksList
    )

  useEffect(() => {
    if (!hasLoaded.current && isMounted.current && works) {
      hasLoaded.current = true
    }
  }, [works])

  useEffect(() => {
    if (contest && isMounted.current) {
      dispatch(actions.fetchWorks(contest.contest_id, search, limit, 1))
      setPage(1)
    }
  }, [debouncedSearchTerm])

  useEffect(() => {
    if (contest && isMounted.current && page > 1) {
      dispatch(actions.fetchWorks(contest.contest_id, search, limit, page))
    }
  }, [page])

  useEffect(() => {
    if (contest && isMounted.current) {
      dispatch(actions.fetchWorks(contest.contest_id, search, limit, page))
    }
  }, [limit])

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchContest())
    isMounted.current = true
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (contest && isMounted.current) {
      dispatch(actions.fetchWorks(contest.contest_id, search, limit, page))
    }
  }, [contest])

  return (
    <>
      <Header />
      <div className={'container'}>
        {(isFetchingContests || isFetchingWorks || !isMounted.current) &&
        !hasLoaded.current ? (
          <LoadingPage />
        ) : contest ? (
          works && metaWorks ? (
            <div className={'profile-contests-works-list'}>
              <div className={'profile__leaf'}>
                <ImageGreenLeaf />
              </div>
              <div className={'profile-contests-works-list__header'}>
                <input
                  placeholder={'Поиск'}
                  onChange={event => setSearch(event.target.value)}
                />
                <div className={'icon-search'}>
                  <IconSearch />
                </div>
              </div>
              <div className={'profile-contests-works-list__title'}>
                БАЗА ИССЛЕДОВАТЕЛЬСКИХ РАБОТ ШКОЛЬНИКОВ ПО ГЕНЕАЛОГИИ
              </div>
              <ContestsDatabaseBlock
                works={works}
                style={{ marginBottom: 36 }}
              />
              <div className={'profile-contests-works-list__footer'}>
                <button
                  disabled={metaWorks.last_page === page}
                  onClick={() => setPage(prev => prev + 1)}
                >
                  посмотреть еще
                </button>
                {sizeButtons.map(sizeValue => (
                  <button
                    className={sizeValue === limit ? 'active' : ''}
                    key={`limit_${sizeValue}`}
                    onClick={() => setLimit(sizeValue)}
                    disabled={
                      metaWorks.total < sizeValue &&
                      sizeValue !== sizeButtons[0]
                    }
                  >
                    {sizeValue} РАБОТ
                  </button>
                ))}
              </div>
              <button
                onClick={() => history.push('/profile/contests')}
                className={'profile-contests-works-list__button-add'}
              >
                Загрузить работу
              </button>
            </div>
          ) : (
            <h1 style={{ textAlign: 'center' }}>
              В настоящий момент нет работ
            </h1>
          )
        ) : (
          <h1 style={{ textAlign: 'center' }}>
            В настоящий момент активных конкурсов нет
          </h1>
        )}
      </div>
      <Footer />
    </>
  )
}
